import { axios } from 'services/axios'
import { routes } from 'services/routes'

import {
  FetchUserCarouselsResponse,
  UpdateUserCarouselsArguments,
  UpdateUserCarouselsResponse,
} from './types'

export const fetchUserCarousels = async () => {
  const response = await axios.get<FetchUserCarouselsResponse>(
    routes.userCarouselsPath(),
  )
  if (!response) {
    throw new Error('Couldn\'t fetch user carousels')
  }
  return response.data
}

export const updateUserCarousels = async ({
  slug,
  dismissed,
}: UpdateUserCarouselsArguments) => {
  const response = await axios.put<UpdateUserCarouselsResponse>(
    routes.userCarouselsPath({ dismissed, slug }),
  )

  if (!response) {
    throw new Error('Couldn\'t update User Carousels')
  }

  return response.data
}
